<template>
  <el-dialog
    title=""
    :visible="visible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :show-close="false"
    append-to-body
    width="400px"
    >
      <div>
        <p class="tips">{{$t('message.frequentlyTips')}}</p>
        <div class="code-img">
          <div class="img-box" v-loading="loading">
            <img v-if="codeUrl" :src="codeUrl" alt="" @click="getCheckCode" @error="imgError">
          </div>
          <span @click="getCheckCode">{{$t('btn.refresh')}}</span>
        </div>
        <div class="handler">
          <el-input
            type="text"
            placeholder=""
            v-model="checkCode"
            maxlength="6"
          >
          </el-input>
          <el-button type="primary" @click="submit">{{$t('btn.confirm')}}</el-button>
        </div>
      </div>
  </el-dialog>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import { blobDownload } from '@/utils/blob-download'
export default {
  name: 'export-dialog',
  data () {
    return {
      visible: false,
      codeUrl: '',
      checkCode: '',
      loading: false,
      errorNum: 0 // 图片重试次数
    }
  },
  watch: { 
    isShowCheckCode: {
      handler(n,o) {
        this.visible = n
        if(n) {
          this.getCheckCode()
          this.$Track.webTrackClick({
            click_code: 'frequent_request_interface_v1.7.0_01',
          })
        }else {
          this.codeUrl = ''
          this.checkCode = ''
        }
      },
      immediate: true
    }
  },
  props: {
  },
  computed: {
    ...mapGetters('login', ['isShowCheckCode'])
  },
  created() {
  },
  mounted() {
  },
  methods: {
    ...mapMutations('login', ['UPDATE_IS_SHOW_CHECK_CODE']),
    ...mapActions('login', ['getCheckCodeApi', 'submitChckeCodeApi']),
    async getCheckCode() {
      const params = {
        pageCode: this.$route.path
      }
      try {
        this.loading = true
        const response = await this.getCheckCodeApi(params)
        const blob = new Blob([response.data], { type: 'application/octet-stream' })
        const href = URL.createObjectURL(blob)
        this.codeUrl = href
        this.loading = false
      } catch(e) {
        this.codeUrl = ''
        this.loading = false
      }
      
    },
    async submit() {
      if(this.checkCode && this.checkCode.length === 6) {
        const params = {
          checkCode: this.checkCode.toLowerCase(),
          pageCode: this.$route.path
        }
        const res = await this.submitChckeCodeApi(params)
        if(res && res.errorCode === 200) {
          this.UPDATE_IS_SHOW_CHECK_CODE(false)
          this.$message.success(this.$t('message.success'))
          location.reload()
        }else {
          this.checkCode = ''
          this.getCheckCode()
        }
      }else {
        this.$message.error(this.$t('message.verificationCodeRequired'))
      }
    },
    imgError() {
      if(this.errorNum >= 3) return
      this.errorNum++
      this.getCheckCode()
    }
  }
}
</script>

<style lang="stylus" scoped>
.tips
  font-size 12px
  font-weight bold
  line-height 14px
  margin-bottom 20px
  color #000
.code-img
  height 50px
  line-height 50px
  margin-bottom 32px
  .img-box
    width 124px
    height 50px
    display inline-block
    img
      width 100%
      height 100%
      margin-right 20px
      vertical-align middle
  span 
    margin-left 20px
    color #999999
    cursor pointer

.handler
  .el-input
    width 124px
    margin-right 24px
    >>>.el-input__inner
      height 32px
      line-height 32px
  button
    padding 9px 20px
</style>



// WEBPACK FOOTER //
// src/components/content/checkCode/index.vue